import { createReducer, Action, on } from '@ngrx/store';
import {
  createFormGroupState,
  onNgrxForms,
  updateGroup,
  onNgrxFormsAction,
  SetValueAction,
  wrapReducerWithFormStateUpdate,
  validate,
  updateArray,
  removeArrayControl,
  setValue,
} from 'ngrx-forms';
import { AddSuperFundAction, RemoveSuperFundAction, ResetFormStateAction, SelectedProviderAction, TransferOptionsResponseAction } from './actions';
import { number, required, requiredTrue } from 'ngrx-forms/validation';
import { Helper } from '@ifaa-components/ui-components';
import { RollinModel } from 'src/app/model/rollin.model';
import { SuperFundModel } from 'src/app/model/superfund.model';
import { IRollinState } from './state';

const formName = 'rollin';

const helper: Helper = new Helper();

const defaultState: IRollinState = {
  form: createFormGroupState(formName, new RollinModel()),
  transferOptions: null,
  savedSuperFunds: [],
};

const validateRollin = updateGroup<RollinModel>({
  superFundList: updateArray<SuperFundModel>(
    updateGroup<SuperFundModel>({
      usi: validate(required),
      memberNumber: validate(required),
      amountToTransfer: validate(number),
    })
  ),
  rolloverAgreement: validate(requiredTrue)
});

const reducer = createReducer(
  defaultState,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, _action) => {
    return state;
  }),
  on(TransferOptionsResponseAction, (state, { transferOptions }) => {
    return {
      ...state,
      transferOptions
    }
  }),
  on(SelectedProviderAction, (state, { id, usi, product, abn, name }) => {
    var clone = helper.clone(state.form.value);

    var index = clone.superFundList.length - 1;

    clone.superFundList[index].providerId = id;
    clone.superFundList[index].usi = usi;
    clone.superFundList[index].productName = product;
    clone.superFundList[index].abn = abn;
    clone.superFundList[index].nameOfSuperFund = name;

    var newForm = setValue(clone)(state.form);
    return {
      ...state,
      form: newForm,
    };
  }),
  on(AddSuperFundAction, (state) => {
    var clone = helper.clone(state.form.value);
    clone.superFundList.push(new SuperFundModel());
    return {
      ...state,
      form: setValue(clone)(state.form),
      validated: false,
    };
  }),
  on(RemoveSuperFundAction, (state, { index }) => {
    return {
      ...state,
      form: updateGroup(state.form, {
        superFundList: removeArrayControl(index),
      }),
      validated: false,
    };
  }),
  on(ResetFormStateAction, (state) => {
    return {
      ...state,
      form: createFormGroupState(formName, new RollinModel())
    }
  })
);

const editRollinVerificationDataFormState = wrapReducerWithFormStateUpdate(
  reducer,
  s => s.form,
  validateRollin
)

export function rollinReducer(state: any | undefined, action: Action) {
  return editRollinVerificationDataFormState(state, action);
}
